<!--
  ⚠ EVERY INTERACTION IS STOPPED FROM ESCAPING THIS PANEL.

  A `mat-menu` closes on any click that reaches it, and `mat-datepicker` opens its calendar in a
  SEPARATE CDK overlay stacked above the menu. Without these guards, picking a date dismisses the
  whole panel — taking the other half of the range the user had already chosen with it, so the
  range can never be completed. `keydown` is stopped for the same reason: the menu's own keyboard
  handling treats arrow keys as item navigation and Escape as close, which would otherwise fight
  the calendar and the text inputs for them.
-->
<div class="date-range-menu" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">

  <!-- Quick picks first: for most people one of these IS the answer, and making them scan two
       date fields to arrive at "the last 12 months" would be slower than the button this
       replaced. -->
  <div class="preset-row" *ngIf="presets?.length">
    <button mat-stroked-button type="button" class="preset-chip"
      *ngFor="let preset of presets"
      [class.active]="isPresetActive(preset)"
      (click)="applyPreset(preset)">
      {{ preset.label }}
    </button>
  </div>

  <div class="field-row">
    <mat-form-field appearance="outline" class="date-field">
      <mat-label>Start Date</mat-label>
      <input matInput [matDatepicker]="rangeStartPicker" [(ngModel)]="start" [max]="maxDate"
        placeholder="DD/MM/YYYY">
      <mat-datepicker-toggle matSuffix [for]="rangeStartPicker"></mat-datepicker-toggle>
      <mat-datepicker #rangeStartPicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" class="date-field">
      <mat-label>End Date</mat-label>
      <!-- `[min]="start"` rather than validating after the fact: the invalid half of the
           calendar is simply not offered, which is a better answer than an error message. -->
      <input matInput [matDatepicker]="rangeEndPicker" [(ngModel)]="end" [max]="maxDate" [min]="start"
        placeholder="DD/MM/YYYY">
      <mat-datepicker-toggle matSuffix [for]="rangeEndPicker"></mat-datepicker-toggle>
      <mat-datepicker #rangeEndPicker></mat-datepicker>
    </mat-form-field>
  </div>

  <p class="range-hint" *ngIf="hint">{{ hint }}</p>

  <!-- Says WHY Apply is off. A disabled button with no explanation is a dead end, and the
       commonest cause here — one field filled, one empty — is invisible at a glance. -->
  <p class="range-error" *ngIf="validationMessage">{{ validationMessage }}</p>

  <!-- ⚠ The consumer closes the menu on `rangeApplied`, because this button cannot: it sits
       inside the propagation guard above, so its click never reaches the menu that would
       otherwise close on it. Without that, Apply leaves the panel sitting open over the page it
       has just changed. -->
  <div class="action-row">
    <button mat-flat-button color="primary" type="button"
      [disabled]="!isValid" (click)="apply()">
      {{ applyLabel }}
    </button>
  </div>
</div>
